export default function phoneNumberValidator(message: any): any {
  return this.transform((value) => value.replace(/^\+/, "")).test(
    "phoneNumber",
    message,
    function (value) {
      const { path, createError } = this;
      const numericStringRegex = /^[0-9]{7,15}$/;
      let valueToValidate = String(value);

      if (!numericStringRegex.test(valueToValidate)) {
        return createError({ path, message });
      }

      return true;
    },
  );
}
